import React from 'react';
import { Modal, Button, Form, Divider } from 'antd';
import { RangeDate } from 'components/datetime';
import useDeleteFile from '../hooks/useDeleteFile';

const ModalDeleteFile = ({ visible, hideModal, fetchTable }) => {
    const [formDeleteFile] = Form.useForm(); // Initialize form instance
    const {
        loading,
        handleSubmit,
    } = useDeleteFile(fetchTable, hideModal);


    return (
        <Modal
            maskClosable={false}
            title={"Konfirmasi"}
            open={visible}
            onCancel={hideModal}
            width={300}
            footer={null}
        >
            <Form
                form={formDeleteFile}
                name="basic"
                autoComplete="off"
                layout="vertical"
                onFinish={handleSubmit}
                loading={loading}
            >
                <Form.Item label="Tanggal" name="tgl">
                    <RangeDate />
                </Form.Item>

                <p>Apakah anda yakin ingin menghapus file absensi?</p>
                <Divider />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    <Button onClick={hideModal} disabled={loading}>Batal</Button>
                    <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>Lanjutkan</Button>
                </div>
            </Form>
        </Modal>
    );
};

export default ModalDeleteFile;
